query currentTeacher($teamId: ID!) {
  currentTeacher(teamId: $teamId) {
    id
    first
    last
    email
    user {
      id
    }
    forwardingNumber
    formattedForwardingNumber
    insertedAt
    team {
      id
      name
    }
    teacherPhoneNumbers {
      id
      number
      formattedNumber
    }
  }
}
